import React, { useState, useEffect } from "react";
import { Button, Descriptions, Tag, Switch, Modal, message, Badge } from "antd";
import { EditOutlined, CalendarOutlined } from "@ant-design/icons";
import { isSuperAdmin } from "../../helpers/permissions";
import "./StaffDetails.css";

export default function StaffDetails({
  staff,
  onEdit,
  onViewAttendance,
  onStatusChange
}) {
  const [statusLoading, setStatusLoading] = useState(false);

  const handleStatusChange = async (checked) => {
    Modal.confirm({
      title: "Confirm Status Change",
      content: `Are you sure you want to ${checked ? "activate" : "deactivate"} this staff member?`,
      onOk: async () => {
        setStatusLoading(true);
        try {
          await onStatusChange(staff, checked);
        } finally {
          setStatusLoading(false);
        }
      },
    });
  };

  const getStaffTypeColor = (type) => {
    switch (type) {
      case "admin":
        return "red";
      case "superadmin":
        return "purple";
      case "delivery":
        return "blue";
      case "package":
        return "cyan";
      default:
        return "green";
    }
  };

  return (
    <div className="staff-details-container">
      <Descriptions bordered column={1} size="small">
        <Descriptions.Item label="Username">
          {staff.username || "N/A"}
        </Descriptions.Item>
        <Descriptions.Item label="Staff Name">
          {staff.name || "N/A"}
        </Descriptions.Item>
        <Descriptions.Item label="Mobile">
          {staff.mobile || "N/A"}
        </Descriptions.Item>
        <Descriptions.Item label="Email">
          {staff.email || "N/A"}
        </Descriptions.Item>
        <Descriptions.Item label="Store">
          {staff.store_name || "N/A"}
        </Descriptions.Item>
        <Descriptions.Item label="Type">
          <Tag color={getStaffTypeColor(staff.type)}>
            {staff.type || "staff"}
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item label="App Version">
          {staff.app_version || "N/A"}
        </Descriptions.Item>
        <Descriptions.Item label="App Platform">
          {staff.app_platform || "N/A"}
        </Descriptions.Item>
        <Descriptions.Item label="Active Status">
          <span className={`status-badge ${staff.is_active === 1 ? 'active' : 'inactive'}`}>
            {staff.is_active === 1 ? 'Active' : 'Inactive'}
          </span>
        </Descriptions.Item>
      </Descriptions>

      <div style={{ marginTop: "24px", display: "flex", gap: "12px", flexDirection: "column" }}>
        {isSuperAdmin() && (
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={onEdit}
            block
          >
            Edit Staff Details
          </Button>
        )}
        <Button
          icon={<CalendarOutlined />}
          onClick={onViewAttendance}
          block
        >
          View Attendance
        </Button>
      </div>
    </div>
  );
}
